import React, { useState } from 'react';
import { FaUser, FaEllipsisH } from "react-icons/fa";
import { MenuPopup } from '@prosolve/common-components-ui'
import { checkHasEditEventPermissions } from '../../utils';
import useIsMobileView from "../../hooks/useIsMobileView";

export default ({
  id = '',
  name = '',
  email = '',
  phone = '',
  requestStatus = '',
  hideBorder,
  onDelete,
}) => {
  const isMobileView = useIsMobileView();

  const hasEditPermissions = checkHasEditEventPermissions();

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const onMenuSelection = (val) => {
    if (val === 'Delete') {
      onDelete(id)
    }
  }

  const formatRequestStatus = (rStatus) => {
    if (rStatus === 'Waiting to Send' || rStatus === 'Requested') {
      return 'Requested'
    } else {
      return 'Accepted'
    }
  }

  return (
      <div style={{
        display: 'flex',
        flex: isMobileView ? 1 : 'none',
        width: isMobileView ? 'calc(100vw - 130px)': 'auto',
        overflow: 'hidden',
        position: 'relative',
        padding: '20px',
        paddingBottom: Boolean(requestStatus) ? '25px' : '20px',
        alignItems: 'flex-start',
        border: hideBorder ? 'none' : '1px solid #c4c4c4',
        borderRadius: '10px'
      }}>
        <div style={{
          height: '50px',
          width: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '22px',
          background: '#C2C9D1',
          color: '#ffffff',
          borderRadius: '50%',
        }}>
          <FaUser />
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '0px 10px 10px 20px',
          overflow: 'hidden',
          wordWrap: 'break-word'
        }}>
          {!name
            ?
            <div style={{ color: '#565656' }}>No user assigned</div>
            :
            <>
              <div style={{
                marginBottom: '10px',
                fontWeight: 'bold'
              }}>
                {name}
              </div>
              <div style={{
                marginBottom: '5px',
                color: '#565656',
              }}>
                {phone 
                  ? phone
                  : 'No phone provided'
                }
              </div>
              <div style={{ color: '#0280c6', textDecoration: 'underline' }}>
                {email 
                  ? email
                  : 'No email provided'
                }
              </div>
              {
                Boolean(requestStatus) &&
                <div style={{ color: '#565656', fontStyle: 'italic', fontSize: '12px', position: 'absolute', bottom: '7px', left: '20px' }}>
                  {formatRequestStatus(requestStatus)}
                </div>
              }
            </>
          }
        </div>
        {
          hasEditPermissions && Boolean(onDelete) &&
          <div style={{ position: 'absolute', top: '0px', right: '0px' }}>
            <FaEllipsisH
              style={{ color: '#7e7e7e', fontSize: '12px', padding: '10px', cursor: 'pointer' }}
              onClick={(e) => { e.stopPropagation(); setIsMenuOpen(true) }}
            />
            <MenuPopup
              open={isMenuOpen}
              top='30px'
              left='-50px'
              options={['Delete']}
              onClose={() => setIsMenuOpen(false)}
              onSelection={(val) => onMenuSelection(val)}
            />
          </div>
        }
      </div>
  )
}